import script from "./ModalDisclaimer.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDisclaimer.vue?vue&type=script&setup=true&lang=js"

import "./ModalDisclaimer.vue?vue&type=style&index=0&id=7eb5b99e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eb5b99e"]])

export default __exports__